import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericService } from 'app/commons/generic.service';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadComprovanteService extends GenericService {

  private path = environment.url + 'api/v1/upload_comprovante';

  constructor(http: HttpClient) {
    super(http);
  }
  uploadComprovanteGrauEscolaridade(formData: FormData) {
    return this.patchMethodFile(this.path + '/grau_escolaridade', formData);
  }

  uploadComprovanteEstadoCivil(formData: FormData) {
    return this.patchMethodFile(this.path + '/estado_civil', formData);
  }

  uploadComprovanteConjuge(formData: FormData) {
    return this.patchMethodFile(this.path + '/conjuge', formData);
  }
}